import "magnific-popup/dist/jquery.magnific-popup.js";
import "magnific-popup/dist/magnific-popup.css";

$(document).ready(function () {
    $('.popup-video, .popup-gmaps').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: true,
        iframe: {
            patterns: {
                canva: {
                    index: 'canva.com',
                    id: function (url) {
                        // https://www.canva.com/design/DAFhucG1O-Q/watch
                        var m = url.match(/^.+canva.com\/design\/([^_]+)\/.+/);
                        console.log(m);
                        if (m !== null) {
                            if (m[1] !== undefined) {
                                return m[1];
                            }
                        }
                        return null;
                    },

                    src: 'https://www.canva.com/design/%id%/watch?embed'
                }
            }
        }
    });
});
